import React from 'react';
import './footer.css';

const Footer = () => {
    return (
    <footer class=".footer__container">
    <div class="footer__wrapper">
<p>Copyright © 2023 Erik Kam's Studio. All rights reserved.</p>
    </div>
    </footer>
    )
}

export default Footer
